import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpInterceptor, HTTP_INTERCEPTORS, HttpHeaders } from '@angular/common/http';
import { from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { CognitoAuthService } from '../services/cognito-auth.service';

@Injectable()
export class AuthorizationInterceptor implements HttpInterceptor {
  constructor(private auth: CognitoAuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    return from(this.auth.idToken$()).pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        });
        return next.handle(request.clone({ headers }));
      })
    );
  }
}

export const authorizationInterceptorProviders = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthorizationInterceptor,
    multi: true
  }
];
